/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "vi": {
        "nu": ["latn"],
        "year": {
          "0": "năm nay",
          "1": "năm sau",
          "future": {
            "other": "sau {0} năm nữa"
          },
          "past": {
            "other": "{0} năm trước"
          },
          "-1": "năm ngoái"
        },
        "year-short": {
          "0": "năm nay",
          "1": "năm sau",
          "future": {
            "other": "sau {0} năm nữa"
          },
          "past": {
            "other": "{0} năm trước"
          },
          "-1": "năm ngoái"
        },
        "year-narrow": {
          "0": "năm nay",
          "1": "năm sau",
          "future": {
            "other": "sau {0} năm nữa"
          },
          "past": {
            "other": "{0} năm trước"
          },
          "-1": "năm ngoái"
        },
        "quarter": {
          "0": "quý này",
          "1": "quý sau",
          "future": {
            "other": "sau {0} quý nữa"
          },
          "past": {
            "other": "{0} quý trước"
          },
          "-1": "quý trước"
        },
        "quarter-short": {
          "0": "quý này",
          "1": "quý sau",
          "future": {
            "other": "sau {0} quý nữa"
          },
          "past": {
            "other": "{0} quý trước"
          },
          "-1": "quý trước"
        },
        "quarter-narrow": {
          "0": "quý này",
          "1": "quý sau",
          "future": {
            "other": "sau {0} quý nữa"
          },
          "past": {
            "other": "{0} quý trước"
          },
          "-1": "quý trước"
        },
        "month": {
          "0": "tháng này",
          "1": "tháng sau",
          "future": {
            "other": "sau {0} tháng nữa"
          },
          "past": {
            "other": "{0} tháng trước"
          },
          "-1": "tháng trước"
        },
        "month-short": {
          "0": "tháng này",
          "1": "tháng sau",
          "future": {
            "other": "sau {0} tháng nữa"
          },
          "past": {
            "other": "{0} tháng trước"
          },
          "-1": "tháng trước"
        },
        "month-narrow": {
          "0": "tháng này",
          "1": "tháng sau",
          "future": {
            "other": "sau {0} tháng nữa"
          },
          "past": {
            "other": "{0} tháng trước"
          },
          "-1": "tháng trước"
        },
        "week": {
          "0": "tuần này",
          "1": "tuần sau",
          "future": {
            "other": "sau {0} tuần nữa"
          },
          "past": {
            "other": "{0} tuần trước"
          },
          "-1": "tuần trước"
        },
        "week-short": {
          "0": "tuần này",
          "1": "tuần sau",
          "future": {
            "other": "sau {0} tuần nữa"
          },
          "past": {
            "other": "{0} tuần trước"
          },
          "-1": "tuần trước"
        },
        "week-narrow": {
          "0": "tuần này",
          "1": "tuần sau",
          "future": {
            "other": "sau {0} tuần nữa"
          },
          "past": {
            "other": "{0} tuần trước"
          },
          "-1": "tuần trước"
        },
        "day": {
          "0": "Hôm nay",
          "1": "Ngày mai",
          "2": "Ngày kia",
          "future": {
            "other": "sau {0} ngày nữa"
          },
          "past": {
            "other": "{0} ngày trước"
          },
          "-2": "Hôm kia",
          "-1": "Hôm qua"
        },
        "day-short": {
          "0": "Hôm nay",
          "1": "Ngày mai",
          "2": "Ngày kia",
          "future": {
            "other": "sau {0} ngày nữa"
          },
          "past": {
            "other": "{0} ngày trước"
          },
          "-2": "Hôm kia",
          "-1": "Hôm qua"
        },
        "day-narrow": {
          "0": "Hôm nay",
          "1": "Ngày mai",
          "2": "Ngày kia",
          "future": {
            "other": "sau {0} ngày nữa"
          },
          "past": {
            "other": "{0} ngày trước"
          },
          "-2": "Hôm kia",
          "-1": "Hôm qua"
        },
        "hour": {
          "0": "giờ này",
          "future": {
            "other": "sau {0} giờ nữa"
          },
          "past": {
            "other": "{0} giờ trước"
          }
        },
        "hour-short": {
          "0": "giờ này",
          "future": {
            "other": "sau {0} giờ nữa"
          },
          "past": {
            "other": "{0} giờ trước"
          }
        },
        "hour-narrow": {
          "0": "giờ này",
          "future": {
            "other": "sau {0} giờ nữa"
          },
          "past": {
            "other": "{0} giờ trước"
          }
        },
        "minute": {
          "0": "phút này",
          "future": {
            "other": "sau {0} phút nữa"
          },
          "past": {
            "other": "{0} phút trước"
          }
        },
        "minute-short": {
          "0": "phút này",
          "future": {
            "other": "sau {0} phút nữa"
          },
          "past": {
            "other": "{0} phút trước"
          }
        },
        "minute-narrow": {
          "0": "phút này",
          "future": {
            "other": "sau {0} phút nữa"
          },
          "past": {
            "other": "{0} phút trước"
          }
        },
        "second": {
          "0": "bây giờ",
          "future": {
            "other": "sau {0} giây nữa"
          },
          "past": {
            "other": "{0} giây trước"
          }
        },
        "second-short": {
          "0": "bây giờ",
          "future": {
            "other": "sau {0} giây nữa"
          },
          "past": {
            "other": "{0} giây trước"
          }
        },
        "second-narrow": {
          "0": "bây giờ",
          "future": {
            "other": "sau {0} giây nữa"
          },
          "past": {
            "other": "{0} giây trước"
          }
        }
      }
    },
    "availableLocales": ["vi"],
    "aliases": {},
    "parentLocales": {}
  });
}